import { createPortal } from 'react-dom';
import * as MultiGridStyles from '~/components/MultiGrid/styles';
import { INVOICE_FILTER_OPTIONS } from '../constants';

interface IFilterOptionsDropdownProps {
  fieldValue: string;
  fixedAttributes: any;
}

const FilterOptionsDropdown = ({ fieldValue, fixedAttributes }: IFilterOptionsDropdownProps) => {
  const rootNode = document.getElementById('root');
  if (!rootNode) {
    return null;
  }

  return createPortal(
    <MultiGridStyles.HeaderAllOptions className="has-y-scroll" {...fixedAttributes}>
      {(INVOICE_FILTER_OPTIONS[fieldValue] ?? []).map(eachOption => (
        <MultiGridStyles.HeaderEachOption
          key={eachOption.id}
          role="presentation"
          className="cursor-pointer"
          // onClick={() =>
          //   onChangeFilter({
          //     name: eachOption.dataProps['data-name'],
          //     value: eachOption.id,
          //   })
          // }
        >
          {eachOption.name}
        </MultiGridStyles.HeaderEachOption>
      ))}
    </MultiGridStyles.HeaderAllOptions>,
    rootNode,
  );
};

export default FilterOptionsDropdown;
